import React, { useRef, useState, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@material-ui/core';
import { Close, Check, ArrowBack } from '@material-ui/icons';
import { isEqual } from 'lodash';
import PropTypes from 'prop-types';

import { t, canURL } from '~/helpers';

import { Container } from './styles';

function Form({ close, create, loading, active, size, component: Component }) {
  const formRef = useRef(null);

  const [data, setData] = useState({});
  const [btnConfirm, setBtnConfirm] = useState(true);
  const [load, setLoad] = useState(false);

  const { title } = useSelector((state) => state.drawer);
  const { opened } = useSelector((state) => state.dialog);

  async function handleSubmit() {
    if (formRef.current) {
      await setData(formRef.current.getData());
      await formRef.current.submitForm();
    }
  }

  async function handleCloseForm() {
    await setData({});

    if (formRef.current) {
      await formRef.current.setData({});
      await formRef.current.reset();
    }

    await close();
  }

  // Toggle button confirm
  const toggleButtonConfirm = useCallback((value) => {
    setBtnConfirm(value);
  }, []);

  const handleToggleLoading = useCallback((value = true) => {
    setLoad(value);
  }, []);

  useEffect(() => {
    if (!opened) {
      setData({});

      if (formRef.current) {
        formRef.current.reset();
      }
    }
  }, [opened]);

  return (
    <Dialog
      open={opened}
      disableBackdropClick
      disableEscapeKeyDown
      fullWidth
      onClose={() => handleCloseForm()}
      fullScreen={window.innerWidth <= 450}
      maxWidth={size}
    >
      <DialogTitle>{title}</DialogTitle>

      <DialogContent>
        <Container>
          <Component
            reference={formRef}
            create={create}
            data={data}
            active={active}
            toggleConfirmButton={toggleButtonConfirm}
            toggleLoading={handleToggleLoading}
          />
        </Container>
      </DialogContent>

      <DialogActions>
        {isEqual(canURL(), { read: true }) ? (
          <Button
            startIcon={<ArrowBack />}
            color="secondary"
            variant="outlined"
            onClick={() => handleCloseForm()}
          >
            {t('s.geral.botaovoltar')}
          </Button>
        ) : (
          <>
            {btnConfirm && (
              <Button
                startIcon={<Check />}
                color="primary"
                variant="outlined"
                onClick={() => handleSubmit()}
                disabled={loading || load}
              >
                {t('s.geral.botaoconfirmar')}
              </Button>
            )}

            <Button
              startIcon={<Close />}
              color="secondary"
              variant="outlined"
              onClick={() => handleCloseForm()}
              disabled={loading || load}
            >
              {btnConfirm
                ? t('s.geral.botaocancelar')
                : t('s.geral.botaofechar')}
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
}

Form.propTypes = {
  close: PropTypes.func.isRequired,
  create: PropTypes.bool.isRequired,
  loading: PropTypes.bool,
  component: PropTypes.oneOfType([PropTypes.element, PropTypes.func])
    .isRequired,
  active: PropTypes.objectOf(PropTypes.any).isRequired,
  size: PropTypes.string.isRequired,
};

Form.defaultProps = {
  loading: false,
};

export default Form;
